
import React from 'react';
import { MealInfo } from '../daily-tile';
import MealItemTile from './MealItemTile';
import { Badge } from '@/components/ui/badge';

interface MealTypeSectionProps {
  type: 'breakfast' | 'lunch' | 'dinner';
  label: string;
  meals: MealInfo[];
  onShowAllMeals: () => void;
  hideBadge?: boolean;
}

const MealTypeSection: React.FC<MealTypeSectionProps> = ({
  type,
  label,
  meals,
  onShowAllMeals,
  hideBadge = false
}) => {
  if (meals.length === 0) {
    return (
      <div className="text-xs text-muted-foreground">
        No meal planned
      </div>
    );
  }

  if (meals.length === 1) {
    return (
      <div className="space-y-1">
        <MealItemTile meal={meals[0]} />
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {!hideBadge && (
        <div className="flex items-center gap-2">
          <Badge variant="secondary" className="text-xs px-1.5 py-0 h-4">
            {meals.length}
          </Badge>
        </div>
      )}
      <div className="space-y-1">
        {meals.slice(0, 2).map((meal) => (
          <MealItemTile 
            key={`${meal.type}-${meal.id}`} 
            meal={meal}
          />
        ))}
        
        {meals.length > 2 && (
          <button
            onClick={onShowAllMeals}
            className="text-xs text-muted-foreground hover:text-primary transition-colors cursor-pointer"
          >
            +{meals.length - 2} more...
          </button>
        )}
      </div>
    </div>
  );
};

export default MealTypeSection;
